'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _selectNumberDropdown = require('./select-number-dropdown');

var _selectNumberDropdown2 = _interopRequireDefault(_selectNumberDropdown);

var _specialtiesList = require('./specialties-list');

var _specialtiesList2 = _interopRequireDefault(_specialtiesList);

var _dropdown = require('dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _doctifyLogoWhite = require('../../src/img/doctify-logo-white.png');

var _doctifyLogoWhite2 = _interopRequireDefault(_doctifyLogoWhite);

var _profileCollage = require('../../src/img/profile-collage.png');

var _profileCollage2 = _interopRequireDefault(_profileCollage);

var _approval = require('../../src/img/approval.png');

var _approval2 = _interopRequireDefault(_approval);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_AGE = 16;
var PHONE_NUMBER_LENGTH = 11;
var currentYear = new Date().getFullYear() - MIN_AGE;
var earliestYear = 1918;

var validBirthdate = function validBirthdate(birthdate) {
	return birthdate.substring(0, 2) !== '00' && birthdate.substring(3, 6) !== 'xxx' && birthdate.substring(7, 11) !== '0000'; //eslint-disable-line
};

var validatePhone = function validatePhone(number) {
	return typeof number === 'string' && number.length && number.match(/\d/g).length === PHONE_NUMBER_LENGTH;
};

var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var overlay = void 0;
var specialtiesList = void 0;
var modalContainerSpecialist = void 0;

var SignUpModal = function SignUpModal(props) {

	var passwordInput = void 0;

	return _react2.default.createElement(
		'div',
		{ className: props.className },
		props.isOpen && _react2.default.createElement(
			'div',
			{ ref: function ref(div) {
					overlay = div;
					if (overlay) {
						overlay.addEventListener('wheel', (0, _doctifyUtils.stopScroll)(_style2.default.modalContainer, overlay, _style2.default.scrollable), true);
						overlay.addEventListener('touchmove', (0, _doctifyUtils.stopScrollMobile)(_style2.default.modalContainer, _style2.default.scrollable), true);
						overlay.addEventListener('touchstart', _doctifyUtils.setLastY, true);
					}
				},
				className: _style2.default.modalBackground,
				onClick: function onClick(event) {
					if (event.target === overlay) {
						(0, _doctifyUtils.closeModal)(props, overlay);
					}
				} },
			_react2.default.createElement(
				'div',
				null,
				props.firstPageActive &&
				//first page code
				_react2.default.createElement(
					'div',
					{ className: _style2.default.modalContainer + ' ' + _style2.default.modalContainerFirstPage },
					_react2.default.createElement(
						'a',
						{ className: _style2.default.closeButton, onClick: function onClick() {
								return (0, _doctifyUtils.closeModal)(props, overlay);
							} },
						_react2.default.createElement('i', { className: 'ion-ios-close-empty' })
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.firstPageHeader },
						_react2.default.createElement(
							'h2',
							null,
							'Join Doctify Today'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.firstPageBody },
						_react2.default.createElement(
							'button',
							{ className: 'btn solid ' + _style2.default.patientButton,
								onClick: function onClick() {
									props.patientButtonClicked();
									(0, _doctifyUtils.fireGTMevent)('patient_signup_click');
								} },
							'Patient'
						),
						_react2.default.createElement(
							'button',
							{ className: 'btn solid',
								onClick: function onClick() {
									props.specialistButtonClicked();
									(0, _doctifyUtils.fireGTMevent)('specialist_lead_click');
								} },
							'Specialist'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.firstPageFooter },
						_react2.default.createElement(
							'p',
							null,
							'Already a member? ',
							_react2.default.createElement(
								'a',
								{ href: '/login' },
								'Log in'
							)
						)
					)
				),
				props.patientSignUpActive &&
				//patient sign up code
				_react2.default.createElement(
					'div',
					{ className: '' + _style2.default.modalContainer },
					_react2.default.createElement(
						'a',
						{ className: '' + _style2.default.closeButton, onClick: function onClick() {
								return (0, _doctifyUtils.closeModal)(props, overlay);
							} },
						_react2.default.createElement('i', { className: 'ion-ios-close-empty' })
					),
					props.backButtonVisible && _react2.default.createElement(
						'a',
						{ className: _style2.default.backButton, onClick: function onClick() {
								return props.backButtonClicked();
							} },
						_react2.default.createElement('i', { className: 'ion-ios-arrow-left' })
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.firstPageHeader },
						_react2.default.createElement(
							'h2',
							null,
							'Sign Up'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.patientSignUpPageBody },
						_react2.default.createElement(
							'div',
							{ className: _style2.default.instructions },
							_react2.default.createElement(
								'div',
								{ className: _style2.default.alreadyAMember },
								'Already a member? ',
								_react2.default.createElement(
									'a',
									{ href: '/login' },
									'Log in'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.smallText },
								'* Indicates required field'
							)
						),
						_react2.default.createElement(
							'form',
							{ className: _style2.default.formContainer },
							_react2.default.createElement(
								'div',
								{ className: _style2.default.singleInputContainer },
								_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !props.userData.firstname.length ? _style2.default.error : ''),
									type: 'text',
									placeholder: 'First name *',
									required: true,
									onChange: function onChange(event) {
										props.onFirstNameChange(event.target.value);
									} }),
								_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ' + _style2.default.tooltipSignupFirstName + ' ion-information-circled' }),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerFirstName },
									_react2.default.createElement(
										'strong',
										null,
										'Why?'
									),
									' We collect your first name so we know how to address you.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.singleInputContainer },
								_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !props.userData.lastname.length ? _style2.default.error : ''),
									type: 'text',
									placeholder: 'Last name *',
									required: true,
									onChange: function onChange(event) {
										props.onLastNameChange(event.target.value);
									} }),
								_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerLastName },
									_react2.default.createElement(
										'strong',
										null,
										'Why?'
									),
									' We collect your last name so we know how to address you.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.singleInputContainer },
								_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !emailRegex.test(props.accountData.name) ? _style2.default.error : ''),
									type: 'text',
									placeholder: 'Email *',
									required: true,
									onChange: function onChange(event) {
										props.onEmailChange(event.target.value);
									} }),
								_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerEmail },
									_react2.default.createElement(
										'strong',
										null,
										'Why?'
									),
									' We use your email address as to send you account related information and to allow you access to your Doctify account.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.passwordContainer },
								_react2.default.createElement('input', {
									className: 'form-control ' + _style2.default.passwordInput + ' ' + (props.submitFailed && !props.accountData.password.length ? _style2.default.error : ''),
									ref: function ref(input) {
										passwordInput = input;
									},
									type: props.typePassword ? 'password' : 'text',
									placeholder: 'Password *',
									onChange: function onChange(event) {
										props.onPasswordChange(event.target.value);
									}
								}),
								_react2.default.createElement(
									'span',
									{ onClick: function onClick() {
											props.toggleShowPassword(props.typePassword, passwordInput.value);
										} },
									'SHOW'
								),
								_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerPassword },
									_react2.default.createElement(
										'strong',
										null,
										'Why?'
									),
									' This is your personal password to access your Doctify account. No one will have access to this except for you.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.radioContainer + ' ' + _style2.default.hidden },
								_react2.default.createElement(
									'div',
									{ className: _style2.default.radioTitle },
									'Gender *'
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'maleRadioOption', className: props.submitFailed && !props.userData.gender.length ? _style2.default.errorRadio : '' },
									'Male'
								),
								_react2.default.createElement('input', { id: 'maleRadioOption',
									type: 'radio',
									name: 'gender',
									onChange: function onChange() {
										props.onGenderChange('m');
									} }),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'femaleRadioOption', className: props.submitFailed && !props.userData.gender.length ? _style2.default.errorRadio : '' },
									'Female'
								),
								_react2.default.createElement('input', { id: 'femaleRadioOption',
									type: 'radio',
									name: 'gender',
									onChange: function onChange() {
										props.onGenderChange('f');
									} }),
								_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ' + _style2.default.tooltipGenderPatient + ' ion-information-circled' }),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerGender },
									_react2.default.createElement(
										'strong',
										null,
										'Why?'
									),
									' We use your gender to tailor your Doctify service.'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.radioContainer },
								_react2.default.createElement(
									'div',
									{ className: _style2.default.radioTitleDob },
									'Date of Birth *'
								),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.datePicker },
									_react2.default.createElement(_selectNumberDropdown2.default, {
										className: _style2.default.dropdown + ' ' + _style2.default.day + ' ' + (props.submitFailed && !validBirthdate(props.userData.birthdate) ? _style2.default.error : '') + ' form-control',
										category: 'Day *',
										start: 1,
										end: 31,
										onOptionSelect: props.onBirthdateDayChange
									}),
									_react2.default.createElement('i', { className: _style2.default.dropdownIconDay + ' ion-chevron-down' }),
									_react2.default.createElement(
										'select',
										{ className: _style2.default.dropdown + ' ' + _style2.default.month + ' ' + (props.submitFailed && !validBirthdate(props.userData.birthdate) ? _style2.default.error : '') + ' form-control',
											onChange: function onChange(event) {
												props.onBirthdateMonthChange(event.target.value);
											},
											defaultValue: 'default' },
										_react2.default.createElement(
											'option',
											{ disabled: true, value: 'default' },
											'Month *'
										),
										_react2.default.createElement(
											'option',
											{ value: 'jan' },
											'January'
										),
										_react2.default.createElement(
											'option',
											{ value: 'feb' },
											'February'
										),
										_react2.default.createElement(
											'option',
											{ value: 'mar' },
											'March'
										),
										_react2.default.createElement(
											'option',
											{ value: 'apr' },
											'April'
										),
										_react2.default.createElement(
											'option',
											{ value: 'may' },
											'May'
										),
										_react2.default.createElement(
											'option',
											{ value: 'jun' },
											'June'
										),
										_react2.default.createElement(
											'option',
											{ value: 'jul' },
											'July'
										),
										_react2.default.createElement(
											'option',
											{ value: 'aug' },
											'August'
										),
										_react2.default.createElement(
											'option',
											{ value: 'sep' },
											'September'
										),
										_react2.default.createElement(
											'option',
											{ value: 'oct' },
											'October'
										),
										_react2.default.createElement(
											'option',
											{ value: 'nov' },
											'November'
										),
										_react2.default.createElement(
											'option',
											{ value: 'dec' },
											'December'
										)
									),
									_react2.default.createElement('i', { className: _style2.default.dropdownIconMonth + ' ion-chevron-down' }),
									_react2.default.createElement(_selectNumberDropdown2.default, {
										className: _style2.default.dropdown + ' ' + _style2.default.year + ' ' + (props.submitFailed && !validBirthdate(props.userData.birthdate) ? _style2.default.error : '') + ' form-control',
										start: -currentYear,
										end: -earliestYear,
										category: 'Year *',
										onOptionSelect: props.onBirthdateYearChange
									}),
									_react2.default.createElement('i', { className: _style2.default.dropdownIconYear + ' ion-chevron-down' })
								),
								_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerDob },
									_react2.default.createElement(
										'strong',
										null,
										'Why?'
									),
									' Your date of birth helps us to provide age-appropriate settings. We won\'t display it.'
								)
							),
							props.serverErrorMessage && props.serverErrorMessage.length > 0 && _react2.default.createElement(
								'div',
								{ className: _style2.default.errorText },
								props.serverErrorMessage
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.agreeToNotifications + ' df-checkbox' },
							_react2.default.createElement('input', { id: 'agree-terms', className: 'form-control', type: 'checkbox', checked: true }),
							_react2.default.createElement(
								'label',
								{ onClick: function onClick() {
										return props.agreeButtonClicked();
									}, className: props.agreeButtonActive ? '' + _style2.default.labelActive : '', htmlFor: 'agree-terms' },
								'Yes, I\'d like to hear about offers and health news.'
							)
						),
						_react2.default.createElement(
							'button',
							{ type: 'submit',
								onClick: function onClick() {
									if (props.userData.firstname.length && props.userData.lastname.length && emailRegex.test(props.accountData.name) && props.accountData.password.length && validBirthdate(props.userData.birthdate)) {
										props.createAccount(props.accountData).then(function (response) {
											var patient = {
												attributes: {
													gender: props.userData.gender,
													birthdate: props.userData.birthdate
												},
												firstname: props.userData.firstname,
												lastname: props.userData.lastname
											};
											// Next if === janky hack for booking flow auth. See also book appt modal, specialist page, and global redux.
											if (props.shouldSetBookingFlowAuthToken) {
												props.setBookingFlowAuthToken(response.account.auth_token);
												props.setBookingFlowAuthInfo({
													id: response.account.id,
													name: response.account.display_name,
													email: response.account.name,
													auth_token: response.account.auth_token
												});
											}
											return props.makePatientCall({
												account: props.accountData,
												account_id: response.account.id,
												auth_token: response.account.auth_token,
												patient: patient
											});
										}).then(function () {
											(0, _doctifyUtils.fireGTMevent)('patient_signup_submit');
										});
									} else {
										props.validationError();
									}
								},
								className: 'btn solid' },
							'Create Account'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.patientSignUpFooter },
						_react2.default.createElement(
							'p',
							null,
							'By submitting this form you agree to Doctify\'s ',
							_react2.default.createElement(
								'a',
								{ href: '/terms-and-conditions' },
								'Terms of Service'
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.securityInfo },
							_react2.default.createElement('i', { className: 'ion-locked' }),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.securityText },
								'We will never display your information publicly. Your information is protected using SSL encryption (same encryption used by banks).'
							)
						)
					)
				),
				props.specialistSignUpActive &&
				//specialist sign up code
				_react2.default.createElement(
					'div',
					{ className: _style2.default.modalContainer + ' ' + _style2.default.modalContainerSpecialist,
						ref: function ref(div) {
							modalContainerSpecialist = div;
						} },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.innerContainer },
						_react2.default.createElement('div', { className: (props.serverErrorMessage && props.serverErrorMessage.length > 0 ? _style2.default.errorBackground : '') + ' ' + _style2.default.leftSideBackground }),
						_react2.default.createElement(
							'a',
							{ className: _style2.default.backButton, onClick: function onClick() {
									return props.backButtonClicked();
								} },
							_react2.default.createElement('i', { className: 'ion-ios-arrow-left' })
						),
						_react2.default.createElement(
							'a',
							{ className: _style2.default.closeButton, onClick: function onClick() {
									return (0, _doctifyUtils.closeModal)(props, overlay);
								} },
							_react2.default.createElement('i', { className: 'ion-ios-close-empty' })
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.leftSide },
							_react2.default.createElement(
								'div',
								{ className: _style2.default.logoHeader },
								_react2.default.createElement('img', { src: _doctifyLogoWhite2.default }),
								_react2.default.createElement(
									'span',
									null,
									'Finding healthcare your way'
								)
							),
							_react2.default.createElement('img', { className: _style2.default.facesImage, src: _profileCollage2.default }),
							_react2.default.createElement(
								'h5',
								null,
								'Join Doctify today'
							),
							_react2.default.createElement(
								'ul',
								{ className: _style2.default.signUpText },
								_react2.default.createElement(
									'li',
									{ className: _style2.default.bulletPoints },
									'Registered with a recognised professional body and currently in good standing'
								),
								_react2.default.createElement(
									'li',
									{ className: _style2.default.bulletPoints },
									'Fully-trained with a minimum of two years experience as a specialist'
								),
								_react2.default.createElement(
									'li',
									{ className: _style2.default.bulletPoints },
									'Recognised as a specialist in your field'
								)
							),
							_react2.default.createElement('img', { className: _style2.default.bottomImage, src: _approval2.default })
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.rightSide },
							_react2.default.createElement(
								'div',
								{ className: _style2.default.firstPageHeader },
								_react2.default.createElement(
									'h2',
									null,
									'Sign Up'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.patientSignUpPageBody },
								_react2.default.createElement(
									'div',
									{ className: _style2.default.instructions },
									_react2.default.createElement(
										'div',
										{ className: _style2.default.alreadyAMember },
										'Already a member? ',
										_react2.default.createElement(
											'a',
											{ href: '/login' },
											'Log in'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.smallText },
										'* Indicates required field'
									)
								),
								_react2.default.createElement(
									'form',
									{ className: _style2.default.formContainer },
									_react2.default.createElement(
										'div',
										{ className: '' + _style2.default.radioContainer },
										_react2.default.createElement(
											'div',
											{ className: _style2.default.radioTitle },
											'Gender *'
										),
										_react2.default.createElement(
											'label',
											{ htmlFor: 'maleRadioOption', className: props.submitFailed && !props.userData.gender.length ? _style2.default.errorRadio : '' },
											'Male'
										),
										_react2.default.createElement('input', { id: 'maleRadioOption',
											type: 'radio',
											name: 'gender',
											onChange: function onChange() {
												props.onGenderChange('m');
											}
										}),
										_react2.default.createElement(
											'label',
											{ htmlFor: 'femaleRadioOption', className: props.submitFailed && !props.userData.gender.length ? _style2.default.errorRadio : '' },
											'Female'
										),
										_react2.default.createElement('input', { id: 'femaleRadioOption',
											type: 'radio',
											name: 'gender',
											onChange: function onChange() {
												props.onGenderChange('f');
											}
										}),
										_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ' + _style2.default.tooltipGender + ' ion-information-circled' }),
										_react2.default.createElement(
											'div',
											{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerGender },
											_react2.default.createElement(
												'strong',
												null,
												'Why?'
											),
											' We use your gender to tailor your Doctify service.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.multipleInputContainer },
										_react2.default.createElement(
											'div',
											{ className: _style2.default.innerMultipleInputContainer },
											_react2.default.createElement(
												'div',
												{ className: _style2.default.dropdownContainer },
												_react2.default.createElement(
													'div',
													{ className: _style2.default.dropdowns },
													_react2.default.createElement(
														'select',
														{ className: _style2.default.dropdown + ' form-control ' + (props.submitFailed && !props.userData.title.length ? _style2.default.error : ''),
															onChange: function onChange(event) {
																props.onTitleChange(event.target.value);
															} },
														_react2.default.createElement(
															'option',
															{ value: '' },
															'Title *'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Dr' },
															'Dr'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Mr' },
															'Mr'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Mrs' },
															'Mrs'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Miss' },
															'Miss'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Ms' },
															'Ms'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Professor' },
															'Professor'
														),
														_react2.default.createElement(
															'option',
															{ value: 'Lord' },
															'Lord'
														)
													),
													_react2.default.createElement('i', { className: _style2.default.dropdownIconMonth + ' ion-chevron-down' })
												)
											),
											_react2.default.createElement('input', { className: _style2.default.firstNameInput + ' form-control ' + (props.submitFailed && !props.userData.firstname.length ? _style2.default.error : ''),
												type: 'text',
												placeholder: 'First name *',
												required: true,
												onChange: function onChange(event) {
													props.onFirstNameChange(event.target.value);
												} }),
											_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ' + _style2.default.tooltipSignupFirstNameSpecialist + ' ion-information-circled' }),
											_react2.default.createElement(
												'div',
												{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerFirstNameSpecialist },
												_react2.default.createElement(
													'strong',
													null,
													'Why?'
												),
												' We collect your first name so we know how to address you.'
											)
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.singleInputContainer },
										_react2.default.createElement('input', { className: _style2.default.lastNameInput + ' form-control ' + (props.submitFailed && !props.userData.lastname.length ? _style2.default.error : ''),
											type: 'text',
											placeholder: 'Last name *',
											required: true,
											onChange: function onChange(event) {
												props.onLastNameChange(event.target.value);
											} }),
										_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
										_react2.default.createElement(
											'div',
											{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerLastName },
											_react2.default.createElement(
												'strong',
												null,
												'Why?'
											),
											' We collect your last name so we know how to address you.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.singleInputContainer },
										_react2.default.createElement('input', { className: _style2.default.contactNumberInput + ' form-control ' + (props.submitFailed && !validatePhone(props.userData.personal_phone) ? _style2.default.error : ''),
											type: 'text',
											placeholder: 'Contact number *',
											required: true,
											onChange: function onChange(event) {
												props.onPhoneNumberChange(event.target.value);
											} }),
										_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
										_react2.default.createElement(
											'div',
											{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerNumber },
											_react2.default.createElement(
												'strong',
												null,
												'Why?'
											),
											' We use your number to contact you about your Doctify account.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.singleInputContainer },
										_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !emailRegex.test(props.accountData.name) ? _style2.default.error : ''),
											type: 'text',
											placeholder: 'Email *',
											required: true,
											onChange: function onChange(event) {
												props.onEmailChange(event.target.value);
											} }),
										_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
										_react2.default.createElement(
											'div',
											{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerEmail },
											_react2.default.createElement(
												'strong',
												null,
												'Why?'
											),
											' We use your email address as to send you account related information and to allow you access to your Doctify account.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.specialtiesListContainer + ' ' + _style2.default.singleInputContainer },
										_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !props.activeListItem ? _style2.default.error : ''),
											type: 'text',
											placeholder: 'Specialty *',
											required: true,
											readOnly: true,
											onClick: function onClick() {
												return props.setSpecialtyListActive();
											},
											value: props.activeListItem && props.activeListItem.name || null
										}),
										_react2.default.createElement('i', { className: _style2.default.downArrow + ' ion-chevron-down' }),
										_react2.default.createElement(
											'div',
											null,
											_react2.default.createElement(_specialtiesList2.default, {
												className: (props.specialtyListActive ? _style2.default.specialtiesListActive : '') + ' ' + _style2.default.specialtiesList + ' ' + _style2.default.scrollable,
												specialtiesList: props.specialties,
												setActiveOnClick: function setActiveOnClick(item) {
													return props.setListItemActive(item);
												},
												activeItem: props.activeItem === '',
												ref: function ref(div) {
													specialtiesList = div;
												}
											})
										),
										_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
										_react2.default.createElement(
											'div',
											{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerSpecialty },
											_react2.default.createElement(
												'strong',
												null,
												'Why?'
											),
											' Your specialty will help us improve your ranking in our search results.'
										)
									),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.singleInputContainer + ' ' + _style2.default.passwordContainer },
										_react2.default.createElement('input', {
											className: 'form-control ' + (props.submitFailed && !props.accountData.password.length ? _style2.default.error : ''),
											ref: function ref(input) {
												passwordInput = input;
											},
											type: props.typePassword ? 'password' : 'text',
											placeholder: 'Password *',
											onChange: function onChange(event) {
												props.onPasswordChange(event.target.value);
											}
										}),
										_react2.default.createElement(
											'span',
											{ onClick: function onClick() {
													props.toggleShowPassword(props.typePassword, passwordInput.value);
												} },
											'SHOW'
										),
										_react2.default.createElement('i', { className: _style2.default.tooltipSignup + ' ion-information-circled' }),
										_react2.default.createElement(
											'div',
											{ className: _style2.default.signupModalTooltipContainer + ' ' + _style2.default.tooltipContainerPassword },
											_react2.default.createElement(
												'strong',
												null,
												'Why?'
											),
											' This is your personal password to access your Doctify account. No one will have access to this except for you.'
										)
									)
								),
								props.serverErrorMessage && props.serverErrorMessage.length > 0 && _react2.default.createElement(
									'div',
									{ className: _style2.default.errorText },
									props.serverErrorMessage
								),
								_react2.default.createElement(
									'button',
									{ type: 'submit',
										onClick: function onClick() {
											if (props.userData.gender.length && props.userData.title.length && props.userData.firstname.length && props.userData.lastname.length && validatePhone(props.userData.personal_phone) && emailRegex.test(props.accountData.name) && props.activeListItem && props.accountData.password.length) {
												props.createAccount(props.accountData).then(function (response) {
													if (response && response.account) {
														var specialist = props.userData;
														specialist.specialties = props.activeListItem;
														props.makeSpecialistCall({
															account: props.accountData,
															account_id: response.account.id,
															auth_token: response.account.auth_token,
															specialist: {
																attributes: {},
																firstname: specialist.firstname,
																gender: specialist.gender,
																lastname: specialist.lastname,
																personal_email: props.accountData.name,
																personal_phone: specialist.personal_phone,
																specialties: specialist.specialties,
																title: specialist.title
															}
														}).then(function () {
															(0, _doctifyUtils.fireGTMevent)('lead_submit');
														}).catch(function () {});
													}
												}).catch(function () {});
											} else {
												props.validationError();
											}
										},
										className: 'btn solid' },
									'Create Account'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: _style2.default.patientSignUpFooter },
								_react2.default.createElement(
									'p',
									null,
									'By submitting this form you agree to Doctify\'s ',
									_react2.default.createElement(
										'a',
										{ href: '/terms-and-conditions' },
										'Terms of Service'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: _style2.default.securityInfo },
									_react2.default.createElement('i', { className: 'ion-locked' }),
									_react2.default.createElement(
										'div',
										{ className: _style2.default.securityText },
										'We will never display your information publicly. Your information is protected using SSL encryption (same encryption used by banks).'
									)
								)
							)
						)
					)
				),
				props.patientSubmitSuccess && _react2.default.createElement(
					'div',
					{ className: '' + _style2.default.modalContainer },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.successHeader },
						_react2.default.createElement(
							'span',
							null,
							'Thank You'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.successBody },
						props.shouldSetBookingFlowAuthToken && _react2.default.createElement(
							'p',
							null,
							'You\'re signed up! Please continue with your booking by clicking the button below.'
						),
						_react2.default.createElement(
							'p',
							null,
							'We have sent you an e-mail.'
						),
						_react2.default.createElement(
							'p',
							null,
							'Please check your e-mail',
							props.shouldSetBookingFlowAuthToken && ' after you\'ve finished booking,',
							' and click on the confirmation link to complete your registration.'
						),
						_react2.default.createElement(
							'button',
							{ className: 'btn solid',
								onClick: function onClick() {
									(0, _doctifyUtils.closeModal)(props, overlay);
								} },
							'Continue'
						)
					)
				),
				props.specialistSubmitSuccess && _react2.default.createElement(
					'div',
					{ className: _style2.default.modalContainer + ' ' + _style2.default.modalContainerSpecialist + ' ' + _style2.default.modalSpecialistSuccess },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.successHeader },
						_react2.default.createElement(
							'span',
							null,
							'Thank You'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.leftSide },
						_react2.default.createElement(
							'div',
							{ className: _style2.default.logoHeader },
							_react2.default.createElement('img', { src: _doctifyLogoWhite2.default }),
							_react2.default.createElement(
								'span',
								null,
								'Finding healthcare your way'
							)
						),
						_react2.default.createElement('img', { className: _style2.default.facesImage, src: _profileCollage2.default }),
						_react2.default.createElement(
							'h5',
							null,
							'Membership Benefits'
						),
						_react2.default.createElement(
							'ul',
							{ className: _style2.default.signUpText },
							_react2.default.createElement(
								'li',
								{ className: _style2.default.bulletPoints },
								'Help patients find and book appointments'
							),
							_react2.default.createElement(
								'li',
								{ className: _style2.default.bulletPoints },
								'Display independent patient reviews'
							),
							_react2.default.createElement(
								'li',
								{ className: _style2.default.bulletPoints },
								'Improve your practice utilisation'
							),
							_react2.default.createElement(
								'li',
								{ className: _style2.default.bulletPoints },
								'Enhance your online visibility'
							),
							_react2.default.createElement(
								'li',
								{ className: _style2.default.bulletPoints },
								'Reduce no shows'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.rightSide },
						_react2.default.createElement(
							'span',
							{ className: _style2.default.nextSteps },
							'Next Steps'
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.successBody },
							_react2.default.createElement(
								'ol',
								null,
								_react2.default.createElement(
									'li',
									null,
									'To complete your registration, please check your email inbox and click on the activation link'
								),
								_react2.default.createElement(
									'li',
									null,
									'Doctify Members pay a monthly subsctiption fee. One of our team will contact you in the next 24 hours to help you complete your membership.'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.closeButtonContainer },
							_react2.default.createElement(
								'button',
								{ className: 'btn solid ' + _style2.default.closeButton,
									onClick: function onClick() {
										return (0, _doctifyUtils.closeModal)(props, overlay);
									} },
								'Close'
							)
						)
					)
				)
			)
		)
	);
};

SignUpModal.propTypes = {
	className: require('react').PropTypes.string,
	isOpen: require('react').PropTypes.bool.isRequired,
	firstPageActive: require('react').PropTypes.bool.isRequired,
	patientSignUpActive: require('react').PropTypes.bool,
	patientSubmitSuccess: require('react').PropTypes.bool,
	typePassword: require('react').PropTypes.bool.isRequired,
	agreeButtonActive: require('react').PropTypes.bool.isRequired,
	specialistSignUpActive: require('react').PropTypes.bool,
	specialistSubmitSuccess: require('react').PropTypes.bool,
	specialties: require('react').PropTypes.arrayOf(require('react').PropTypes.string).isRequired,
	specialtyListActive: require('react').PropTypes.bool,
	activeListItem: require('react').PropTypes.object,
	activeItem: require('react').PropTypes.string,
	accountData: require('react').PropTypes.object,
	userData: require('react').PropTypes.object,
	firstname: require('react').PropTypes.any,
	lastname: require('react').PropTypes.any,
	submitFailed: require('react').PropTypes.any,
	serverErrorMessage: require('react').PropTypes.any,
	closeModal: require('react').PropTypes.func.isRequired,
	patientButtonClicked: require('react').PropTypes.func.isRequired,
	specialistButtonClicked: require('react').PropTypes.func.isRequired,
	toggleShowPassword: require('react').PropTypes.func.isRequired,
	agreeButtonClicked: require('react').PropTypes.func.isRequired,
	createAccount: require('react').PropTypes.func.isRequired,
	backButtonClicked: require('react').PropTypes.func.isRequired,
	setSpecialtyListActive: require('react').PropTypes.func.isRequired,
	setListItemActive: require('react').PropTypes.func.isRequired,
	onTitleChange: require('react').PropTypes.func.isRequired,
	onFirstNameChange: require('react').PropTypes.func.isRequired,
	onLastNameChange: require('react').PropTypes.func.isRequired,
	onEmailChange: require('react').PropTypes.func.isRequired,
	onPasswordChange: require('react').PropTypes.func.isRequired,
	onGenderChange: require('react').PropTypes.func.isRequired,
	onBirthdateDayChange: require('react').PropTypes.func.isRequired,
	onBirthdateMonthChange: require('react').PropTypes.func.isRequired,
	onBirthdateYearChange: require('react').PropTypes.func.isRequired,
	onPhoneNumberChange: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired,
	backButtonVisible: require('react').PropTypes.bool.isRequired,
	activationMethod: require('react').PropTypes.any.isRequired
};
SignUpModal.displayName = 'SignUpModal';

SignUpModal.defaultProps = {
	className: 'SignUpModal',
	backButtonVisible: true,
	activationMethod: 'hover'
};

exports.default = SignUpModal;


// WEBPACK FOOTER //
// ./components/sign-up-modal/lib/components/sign-up-modal.js